import { useEffect, useState } from "react";
import { CsrAPI } from "../apis/CsrAPI";

const EMPTY = {};

/**
 * The Patient Narrative wizard question labels - a plain {field: label} map
 * from GET /patient-narratives/questions - fetched fresh each time a page
 * mounts. The info notes and answer choices are not served by that endpoint;
 * they still come from patient_narrative_questions_data.json.
 */
const usePatientNarrativeQuestions = () => {
  const [questions, setQuestions] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    CsrAPI.getPatientNarrativeQuestions()
      .then(data => {
        if (!cancelled) setQuestions(data || EMPTY);
      })
      .catch(err => {
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { questions, loading, error };
};

export default usePatientNarrativeQuestions;
